import React from 'react'
import { Space } from 'antd'
import { CHANNEL_LABELS } from '../notifications/shared/notification-constants'
import './channel-list.scss'

interface ChannelListProps {
    channels: string[]
}

/** Renders a list of channel icons + labels from a notification's channels array. */
export const ChannelList: React.FC<ChannelListProps> = ({ channels }) => {
    if (!channels.length) return null

    return (
        <Space size={8}>
            {channels.map((ch) => {
                const info = CHANNEL_LABELS[ch]
                return info ? (
                    <span key={ch} className="channel-list__item">
                        {info.icon} {info.label}
                    </span>
                ) : (
                    <span key={ch}>{ch}</span>
                )
            })}
        </Space>
    )
}
